import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { IconBlock } from '@contrast-security-inc/design-system-foundations'
import { InformationPanel } from '@contrast-security-inc/design-system-surfaces'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import { Link } from '@contrast-security-inc/design-system-typography'
import { sendDefaultEvent } from '../../../../../components/analytics'

const salesEmail = 'sales@contrastsecurity.com'

export const OssUnlicensedState = () => {
  const intl = useIntl()

  return (
    <Stack>
      <InformationPanel
        className={css`
          width: 100%;
          height: fit-content;
        `}
        Icon={IconBlock}
        IconProps={{
          size: 'lg',
          testId: 'sca-unlicensed-icon'
        }}
        title={intl.formatMessage({
          id: 'action_application_upgradeLicense_panel'
        })}
        subtitle={intl.formatMessage({
          id: 'variable_upgradeOss_panel_subtitle'
        })}
        detail={intl.formatMessage(
          { id: 'variable_upgradeOss_panel_detail' },
          {
            link: (
              <Link
                href={`mailto:${salesEmail}`}
                onClick={() =>
                  sendDefaultEvent('usage.panel.upgrade.license.email')
                }
              >
                {salesEmail}
              </Link>
            )
          }
        )}
      />
    </Stack>
  )
}
